var _circle, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 17.3333C17.3333 18.8061 18.5272 20 20 20C21.4728 20 22.6667 18.8061 22.6667 17.3333C22.6667 15.8605 21.4728 14.6666 20 14.6666C18.5272 14.6666 17.3333 15.8605 17.3333 17.3333Z",
    fill: "url(#paint0_linear_2_14770)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10.6666H12C11.2636 10.6666 10.6667 11.2636 10.6667 12V22.6666C10.6667 23.403 11.2636 24 12 24H28C28.7364 24 29.3333 23.403 29.3333 22.6666V12C29.3333 11.2636 28.7364 10.6666 28 10.6666Z",
    fill: "url(#paint1_linear_2_14770)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26.6666H30M10 29.3333H30M13.3333 15.3333V13.3333H15.3333M24.6667 13.3333H26.6667V15.3333M13.3333 19.3333V21.3333H15.3333M24.6667 21.3333H26.6667V19.3333M20 20C18.5272 20 17.3333 18.8061 17.3333 17.3333C17.3333 15.8605 18.5272 14.6666 20 14.6666C21.4728 14.6666 22.6667 15.8605 22.6667 17.3333C22.6667 18.8061 21.4728 20 20 20ZM12 10.6666H28C28.7364 10.6666 29.3333 11.2636 29.3333 12V22.6666C29.3333 23.403 28.7364 24 28 24H12C11.2636 24 10.6667 23.403 10.6667 22.6666V12C10.6667 11.2636 11.2636 10.6666 12 10.6666Z",
    stroke: "url(#paint2_linear_2_14770)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_14770",
    x1: 20,
    y1: 10.6666,
    x2: 20,
    y2: 29.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_14770",
    x1: 20,
    y1: 10.6666,
    x2: 20,
    y2: 29.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_14770",
    x1: 20,
    y1: 10.6666,
    x2: 20,
    y2: 29.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeesIcon);
export default __webpack_public_path__ + "static/media/fees_icon.22afadf5b7c984f8ef39b576065d793d.svg";
export { ForwardRef as ReactComponent };